import { render, staticRenderFns } from "./pageShortcutBlock.vue?vue&type=template&id=59e461f3&scoped=true"
import script from "./pageShortcutBlock.vue?vue&type=script&lang=js"
export * from "./pageShortcutBlock.vue?vue&type=script&lang=js"
import style0 from "./pageShortcutBlock.vue?vue&type=style&index=0&id=59e461f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e461f3",
  null
  
)

export default component.exports